var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"battery",style:({'box-shadow': ' inset 0 -' + _vm.fill + 'px 0px '+_vm.fillColor, 'border-color':_vm.fillColor}),attrs:{"data-percentage":_vm.convertedPercentage + '%'}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-126e200c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Units/DeviceBattery.vue
// module id = null
// module chunks = 